import { takeLatest, put, call } from 'redux-saga/effects';

import { listPlantioManejoTable } from '../service';
import {
  TABLE_PLANTIO_MANEJO,
  TABLE_PLANTIO_MANEJO_PENDING,
  TABLE_PLANTIO_MANEJO_SUCCESS,
  TABLE_PLANTIO_MANEJO_FAILURE
} from '../actionTypes';

function* sagaListPlantioManejo(action) {
  yield put({ type: TABLE_PLANTIO_MANEJO_PENDING })

  try {
    const table = yield call(listPlantioManejoTable, action.args)
    yield put({ type: TABLE_PLANTIO_MANEJO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_PLANTIO_MANEJO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListPlantioManejo() {
  yield takeLatest(TABLE_PLANTIO_MANEJO, sagaListPlantioManejo)
}